export enum CheckoutCategory {
  BASIC = 'BASIC_SUBSCRIPTION',
  DEFAULT = 'MATCHING_SUBSCRIPTION',
  NEW_SCHOOL = 'NEW_SCHOOL_SUBSCRIPTION',
}
